import { render, staticRenderFns } from "./PageAccesibility.vue?vue&type=template&id=11bfec53"
import script from "./PageAccesibility.vue?vue&type=script&lang=js"
export * from "./PageAccesibility.vue?vue&type=script&lang=js"
import style0 from "./PageAccesibility.vue?vue&type=style&index=0&id=11bfec53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports